import { render, staticRenderFns } from "./CancellationTable.vue?vue&type=template&id=2641cb33&scoped=true&"
import script from "./CancellationTable.vue?vue&type=script&lang=js&"
export * from "./CancellationTable.vue?vue&type=script&lang=js&"
import style0 from "./CancellationTable.vue?vue&type=style&index=0&id=2641cb33&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2641cb33",
  null
  
)

export default component.exports